export const NO_FIRM_SENTENCE = "No firm is linked to this lawyer.";

const GENERIC_SENTENCE = "This can't be looked up for this entry.";

const REASON_SENTENCES: Record<string, string | undefined> = {
  no_firm_ref: "This firm has no firm reference, so its submissions can't be looked up.",
  no_company_wp_id: "This firm isn't linked to WordPress, so its testimonials can't be looked up.",
  no_edition_wp_id: "This edition isn't linked to WordPress, so this can't be looked up.",
  no_bpa_wp_id: "This practice area isn't linked to WordPress, so this can't be looked up.",
};

/** The sentence a researcher reads for why a source-data surface could not be looked up. */
export function unresolvedReasonText(reason: string): string {
  return REASON_SENTENCES[reason] ?? GENERIC_SENTENCE;
}
